import React, { useState, useEffect } from 'react';
import HNavbar from "../../Components/Navbar/HNavbar";
import "../projects/projects.css";
import airports from ".././../Assets/project-imgs/chennai-international-airport.jpg";
import metro from "../../Assets/project-imgs/bangalore-metro.webp";
import construction from "../../Assets/project-imgs/nanu-const-goa.jpg";
import asianpaint from "../../Assets/project-imgs/asian-paints.jpg";
import hal from "../../Assets/project-imgs/HAL_Museum_Bengaluru.jpg";
import reliance from "../../Assets/project-imgs/reliance-pp.jpg";
import recca from ".././../Assets/project-imgs/recca-club.jpg";
import hotels from ".././../Assets/project-imgs/Chalet_1.webp";
import drunken from ".././../Assets/project-imgs/drunken-daddy.avif";
import automotive from ".././../Assets/project-imgs/falcon-autotech.jpg";
import armyscl from ".././../Assets/project-imgs/army-public-scl.jpg";
import MFooter from '../../Components/Main-Footer/MFooter';

function Projects() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    return (
        <>
            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="pro-sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <div className="pro-hero-tag">our projects</div>
                            <h1 className="pro-hero-title">Proven Performance<br />
                                in Real-World Environments
                            </h1>
                            <p className="pro-hero-desc">
                                Delivering reliable acoustic solutions for infrastructure, industrial, commercial and public spaces across diverse geographies.
                            </p>

                            <div className="d-flex flex-wrap gap-2 mt-2">
                                <a href="/" className="btn2 btn2-orange d-inline-flex align-items-center gap-2">
                                    REQUEST A QUOTE&nbsp;<i className="fa fa-arrow-right"></i>
                                </a>
                                <a href="/" className="btn2 btn2-outline-dark-sb d-inline-flex align-items-center gap-2">
                                    DOWNLOAD BROCHURE&nbsp;<i className="fa fa-download"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== PROJECT CARDS ===== */}
            <section className="project-showcase">
                <div className="container showcase-grid">

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={hotels} alt="Chalet Hotel" />
                            {/* <span className="tag"><i className="fa-solid fa-bed"></i> Hospitality</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>Chalet Hotel</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Mumbai</span>
                            {/* <div className="showcase-footer">
                                <p>Noise mitigation for enhanced guest comfort and a peaceful stay.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={airports} alt="Airport" />
                            {/* <span className="tag"><i className="fa-solid fa-plane"></i> Airport</span>   */}
                        </div>
                        <div className="showcase-body">
                            <h4>Chennai Airport</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Chennai</span>
                            {/* <div className="showcase-footer">
                                <p>Perimeter noise control for airport adjacent residential areas.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={metro} alt="Metro" />
                            {/* <span className="tag"><i className="fa-solid fa-plane"></i> Airport</span>   */}
                        </div>
                        <div className="showcase-body">
                            <h4>Bangalore Metro</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Bangalore</span>
                            {/* <div className="showcase-footer">
                                <p>Perimeter noise control for airport adjacent residential areas.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={construction} alt="Construction" />
                            {/* <span className="tag"><i className="fa-solid fa-plane"></i> Airport</span>   */}
                        </div>
                        <div className="showcase-body">
                            <h4>Nanu Construction, Goa</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Goa</span>
                            {/* <div className="showcase-footer">
                                <p>Perimeter noise control for airport adjacent residential areas.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={asianpaint} alt="Asian Paints" />
                            {/* <span className="tag"><i className="fa-solid fa-bed"></i> Hospitals</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>Asian Paints, Mumbai</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Mumbai</span>
                            {/* <div className="showcase-footer">
                                <p>Perimeter noise control for airport adjacent residential areas.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={hal} alt="HAL" />
                            {/* <span className="tag"><i className="fa-solid fa-industry"></i> Industrial</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>HAL Bnagalore</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Bnagalore</span>
                            {/* <div className="showcase-footer">
                                <p>Controlled industrial noise for a safer and quieter work environment.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={reliance} alt="Reliance Power Plant" />
                            {/* <span className="tag"><i className="fa-solid fa-building"></i> Commercial Office</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>Reliance Power Plant, Mumbai</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Mumbai</span>
                            {/* <div className="showcase-footer">
                                <p>Perimeter noise control for airport adjacent residential areas.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={armyscl} alt="Educational" />
                            {/* <span className="tag"><i className="fa-solid fa-building"></i> Educational</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>Army School, Bangalore</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Bangalore</span>
                            {/* <div className="showcase-footer">
                                <p>Noise control for enhanced living comfort in a premium residential community.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={recca} alt="recca club" />
                            {/* <span className="tag"><i className="fa-solid fa-building"></i> Residential</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>RECCA Club, Kochi</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Kochi</span>
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={drunken} alt="Drunken Daddy" />
                            {/* <span className="tag"><i className="fa-solid fa-car-side"></i> Automotive</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>Drunk N Daddy, Bangalore</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Bangalore</span>
                            {/* <div className="showcase-footer">
                                <p>Controlled industrial noise for a safer and quieter work environment.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={automotive} alt="Automotive" />
                            {/* <span className="tag"><i className="fa-solid fa-car-side"></i> Automotive</span> */}
                        </div>
                        <div className="showcase-body">
                            <h4>Falcon Autotech, Bangalore</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Bangalore</span>
                            {/* <div className="showcase-footer">
                                <p>Controlled industrial noise for a safer and quieter work environment.</p>
                                <i className="fa-solid fa-arrow-right arrow"></i>
                            </div> */}
                        </div>
                    </div>

                    {/* <div className="showcase-card">
                        <div className="showcase-img">
                            <img src={recordingstudio} alt="recording studio" />
                            <span className="tag"><i className="fa-solid fa-microphone-lines"></i> Recording Studio</span>
                        </div>
                        <div className="showcase-body">
                            <h4>Ipop Audio-Experience Centre</h4>
                            <span className="location"><i className="fa-solid fa-location-dot"></i> Pondicherry</span>
                        </div>
                    </div> */}
                </div>
            </section>
            <section style={{ backgroundColor: "#f8f8f8", marginBottom: "20px" }}>
                <div className='container'>
                    <div style={{ gridColumn: "1 / -1" }}>
                        <div className="col-12 d-flex gap-4 stats-bar">
                            {[
                                { icon: "fa fa-globe", value: "120+", label: "Projects Completed" },
                                { icon: "fa fa-location-dot", value: "10+", label: "Cities" },
                                { icon: "fa fa-check-square", value: "15+", label: "Years of Reliability" },
                                { icon: "fa fa-solid fa-users", value: "Trusted by", label: "Engineers & Developers" },
                            ].map((f) => (
                                <div className="stats-item" key={f.label}>
                                    <i className={f.icon}></i>
                                    <div className="stats-item-text">
                                        <span className="stats-item-value">{f.value}</span>
                                        <span className="stats-item-label">{f.label}</span>
                                    </div>
                                </div>
                            ))}
                            <a href="/" className="btn2 btn2-orange d-inline-flex align-items-center gap-2">
                                REQUEST A QUOTE&nbsp;<i className="fa fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default Projects